var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAvatarBtnNext = function SvgIconAvatarBtnNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.34 15.236a.75.75 0 0 0-.208.536.74.74 0 0 0 .238.523.76.76 0 0 0 .545.205.77.77 0 0 0 .532-.235l6.47-6.746a.743.743 0 0 0 0-1.03l-6.47-6.746a.76.76 0 0 0-.534-.242.77.77 0 0 0-.55.204.75.75 0 0 0-.238.528.74.74 0 0 0 .215.539l5.977 6.232z"
  })));
};
export default SvgIconAvatarBtnNext;